import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function AdminSettings() {
  const [s, setS] = useState({ store_name: "", whatsapp_number: "", free_shipping_threshold: 0, default_shipping: 0 });

  useEffect(() => {
    api.get("/settings").then((r) => setS({
      store_name: r.data.store_name || "",
      whatsapp_number: r.data.whatsapp_number || "",
      free_shipping_threshold: r.data.free_shipping_threshold || 0,
      default_shipping: r.data.default_shipping || 0,
    }));
  }, []);

  const save = async () => {
    try {
      await api.put("/admin/settings", {
        ...s,
        free_shipping_threshold: Number(s.free_shipping_threshold) || 0,
        default_shipping: Number(s.default_shipping) || 0,
      });
      toast.success("Configurações salvas");
    } catch {
      toast.error("Erro ao salvar");
    }
  };

  return (
    <div>
      <div className="overline-label">Operação</div>
      <h1 className="font-display text-4xl text-white tracking-tighter mt-3 mb-8">Configurações</h1>

      <div className="border border-white/10 bg-[#0A0A0C] p-6 max-w-xl space-y-5">
        <Field label="Nome da loja">
          <Input value={s.store_name} onChange={(e) => setS({ ...s, store_name: e.target.value })} className="bg-[#050505] border-white/15 h-11 text-white" data-testid="set-store-name" />
        </Field>
        <Field label="WhatsApp (apenas números com DDI, ex: 5511999999999)">
          <Input value={s.whatsapp_number} onChange={(e) => setS({ ...s, whatsapp_number: e.target.value })} className="bg-[#050505] border-white/15 h-11 text-white" data-testid="set-whatsapp" />
        </Field>
        <div className="grid sm:grid-cols-2 gap-5">
          <Field label="Frete grátis acima de (R$)">
            <Input type="number" step="0.01" value={s.free_shipping_threshold} onChange={(e) => setS({ ...s, free_shipping_threshold: e.target.value })} className="bg-[#050505] border-white/15 h-11 text-white" />
          </Field>
          <Field label="Frete padrão (R$)">
            <Input type="number" step="0.01" value={s.default_shipping} onChange={(e) => setS({ ...s, default_shipping: e.target.value })} className="bg-[#050505] border-white/15 h-11 text-white" />
          </Field>
        </div>
        <div className="pt-3">
          <Button onClick={save} className="bg-white text-black hover:bg-zinc-200 uppercase tracking-widest text-xs h-11 px-6" data-testid="save-settings-btn">Salvar</Button>
        </div>
      </div>

      <div className="border border-white/10 bg-[#0A0A0C] p-6 max-w-xl mt-6">
        <div className="overline-label mb-3">Pagamento</div>
        <p className="text-sm text-zinc-300">A loja está operando em <strong>modo de demonstração</strong>. Os pedidos são criados, mas o pagamento não é cobrado. Para ativar o Mercado Pago em produção, adicione <code className="text-xs bg-black px-1">MP_ACCESS_TOKEN</code> nas variáveis de ambiente e reinicie o backend.</p>
      </div>
    </div>
  );
}

function Field({ label, children }) {
  return <div><Label className="text-xs text-zinc-400 mb-2 block">{label}</Label>{children}</div>;
}
